module.exports = new __parcel__URL__("sig-stats-can-blk-en.ce395c72.svg").toString();